import { defineMessages } from "react-intl";

const messages = defineMessages({
    closeRoom: {
        id: "share.closeRoom",
    },
    restartTask: {
        id: "playPlan.restart",
    },
    restartHomework: {
        id: "homework.restart",
    },
    fancyUI: {
        id: "playPlan.fancyUI",
    },
    giveUp: {
        id: "homework.giveUp",
    },
    exitHomework: {
        id: "homework.exitHomework",
    },
});

export default messages;
